/**
 * These functions were borrowed from: https://codepen.io/matths/pen/yjbis
 * Some eslint rules have been disabled so we don't have to spend time reverse-engineering.
 */

/* eslint-disable no-plusplus */
/* eslint-disable no-cond-assign */
/* eslint-disable no-param-reassign */
const easeInOutQuad: EasingFunction = (x, t, b, c, d): number => {
    if ((t /= d / 2) < 1) {
        return (c / 2) * t * t + b;
    }

    return (-c / 2) * (--t * (t - 2) - 1) + b;
};
/* eslint-enable no-plusplus */
/* eslint-enable no-cond-assign */
/* eslint-disable no-param-reassign */

export const easingFunctions = {
    easeInOutQuad,
};
